export const HEIGHT_MODAL_PAPER = '65vh';
export const WIDTH_PAPER_DESKTOP = '400px';
export const HEIGHT_IMAGE_HEADER = '133px';